<app-page-container header="Page Not Found">
  <p class="px-3 pb-3">Oops, we can't seem to find the page you are looking for. Try going back to the previous page or use the button below.</p>
  <button pButton
    type="button"
    class="p-button-text"
    routerLink="/"
    label="Home">
  </button>
  <button *ngIf="!authenticated" pButton
    class="p-button-text p-button-secondary ml-2"
    type="button"
    routerLink="/member/login"
    label="Member Login">
  </button>
</app-page-container>
